import { render, staticRenderFns } from "./Customerinformation.vue?vue&type=template&id=7a54e9ed&scoped=true&"
import script from "./Customerinformation.vue?vue&type=script&lang=js&"
export * from "./Customerinformation.vue?vue&type=script&lang=js&"
import style0 from "./Customerinformation.vue?vue&type=style&index=0&id=7a54e9ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a54e9ed",
  null
  
)

export default component.exports